export default __webpack_public_path__ + "static/media/icon_circlecheck.ddb3a641.png";